import React, { useEffect, useRef, useState } from "react";
import { VideoMain, VideoBox } from "../Video/styles";
import './VideoModal.css';

const isIOS = () => {
  return (
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    !window.MSStream
  );
};

const isAndroid = () => {
  return (
    typeof navigator !== "undefined" &&
    /Android/.test(navigator.userAgent)
  );
};

const VideoModal = ({ onClose, videoId }) => {
  const playerRef = useRef(null);
  const iframeContainerRef = useRef(null);
  const [isPlayerReady, setIsPlayerReady] = useState(false);

  useEffect(() => {
    if (!videoId) return;

    const createPlayer = () => {
      if (!window.YT || !window.YT.Player || !iframeContainerRef.current) return;

      // Device-specific mute logic
      const muteSetting = isIOS() ? 1 : 0;

      playerRef.current = new window.YT.Player(iframeContainerRef.current, {
        width: 560,
        height: 315,
        videoId,
        playerVars: {
          autoplay: 1,
          mute: muteSetting,
          rel: 0,
          modestbranding: 1,
          enablejsapi: 1,
          fs: 1,
          playsinline: 1,
        },
        events: {
          onReady: (event) => {
            // Ensure fullscreen is allowed on iframe
            const iframe = iframeContainerRef.current?.querySelector('iframe');
            if (iframe) {
              iframe.setAttribute("allowfullscreen", "true");
              iframe.setAttribute("webkitallowfullscreen", "true");
              iframe.setAttribute("mozallowfullscreen", "true");
            }
        
            if (!isIOS()) {
              event.target.unMute();
            }
            event.target.playVideo();
            setIsPlayerReady(true);
          },
        },
      });
    };

    // Load YouTube API script if not already loaded
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);

      window.onYouTubeIframeAPIReady = () => {
        createPlayer();
      };
    } else {
      createPlayer();
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [videoId]);

  if (!videoId) return null;

  return (
    <VideoMain
      className="animate__animated animate__fadeIn"
      videoToggle={true}
      onClick={() => onClose()}
      contentLabel="Video Modal"
    >
      <VideoBox
        className="animate__animated animate__bounceInUp"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="media-close-button-presentation"
          onClick={() => {
            onClose();
          }}
          aria-label="Close Video"
        >
          <span>×</span>
        </button>
        <div
          id="youtube-player"
          ref={iframeContainerRef}
          className="videoframe"
        ></div>
      </VideoBox>
    </VideoMain>
  );
};

export default VideoModal;
